export class JobDetail {
    reportRefID: string;
    jobID: string;
    reportSubType: string;
    status: string;
    requestedDateTime: Date;
    lastUpdateDateTime: Date;
}

export class Job {
    jobID: string;
    reportSubType: string;
    status: string;
    requestedDateTime: Date;
    lastUpdateDateTime: Date;
}
  
export class JobGroup {
    reportRefID: string;
    reportType: string;
    requestedDateTime: Date;
    reportSubTypes?: string;
    statusSummary?: string;
    jobs: Job[];
}

export class BatchReportsGridEvent {
    subject: string;
    eventType: string;
    key?: string;
    data?: any;
}

export class JobObservableConfig {
    statusCheckAft?: number;
    retryInterval?: number;
    maxRetries?: number;

}

export const reportParametersConfig = [
    {
        reportType: 'Location Snapshot',
        paramConfig: [
            {paramName: 'countryIDs', displayName: 'Country', displayOrder: 1},
            {paramName: 'siteNames', displayName: 'Site Names', displayOrder: 2},
            {paramName: 'globalSegments', displayName: 'Global Industry Segments', displayOrder: 3},
            {paramName: 'radiusAroundEachPlant', displayName: 'Radius around each plant (miles)', displayOrder: 4},
            {paramName: 'includeSuspectList', displayName: 'Include Suspect List', displayOrder: 5},
            {paramName: 'removeExcluded', displayName: 'Remove Excluded', displayOrder: 6},
            {paramName: 'crossCountryBorders', displayName: 'Cross Country Borders', displayOrder: 7},
            {paramName: 'limitToSiteRevenueGrtThan1MM', displayName: 'Limit to SiteRevenue > $1M', displayOrder: 8},
            {paramName: 'showDistanceRings', displayName: 'Show Distance Rings', displayOrder: 9},
            {paramName: 'includeSAPCustomerList', displayName: 'Include SAP Customer List', displayOrder: 10},
            {paramName: 'trailerSize', displayName: 'Trailer Size (MT)', displayOrder: 11},
            {paramName: 'distributionCost', displayName: 'Distribution Cost ($/mi)', displayOrder: 12},
            {paramName: 'product', displayName: 'Products', displayOrder: 13},            
        ]
    }
]